(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-base"] && !Shopify.designMode) return;
  try {
    (function () {
    function toggle(card) {
      var open = card.classList.toggle('is-open');
      card.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = card.querySelector('[data-mp-expand-label]');
      if (label) label.textContent = open ? 'Réduire' : 'Lire la suite';
    }
    function setup() {
      document.querySelectorAll('[data-mp-expand]').forEach(function (card) {
        var text = card.querySelector('[data-mp-expand-text]');
        var label = card.querySelector('[data-mp-expand-label]');
        if (!text || !label || card.classList.contains('is-open')) return;
        label.hidden = text.scrollHeight <= text.clientHeight + 2;
      });
    }
    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-mp-expand]');
      if (!card || event.target.closest('a')) return;
      toggle(card);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = event.target.closest('[data-mp-expand]');
      if (!card || event.target !== card) return;
      event.preventDefault();
      toggle(card);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    window.addEventListener('load', setup);
    window.addEventListener('resize', setup);
  })();
  } catch(e) { console.error(e); }
})();

})();
